
<a
  :aria-label="starRatingText + ', average rating for this product'"
  class="rfp-rr-star-rating-product-173-or"
  @click="callToActionRatingsTab"
>
  <vue-star-rating
    :increment="starRatingIncrementValue"
    :max-rating="starRatingMaxRatingValue"
    :inactive-color="starRatingInactiveColor"
    :active-color="starRatingActiveColor"
    :star-size="starRatingStarSize"
    :rating="overallRating"
    :read-only="true"
    :show-rating="false"
  >
  </vue-star-rating>
  <span
    class="rfp-avg-rating-or"
    itemprop="aggregateRating"
    itemscope
    itemtype="https://schema.org/AggregateRating"
  >
    <meta itemprop="ratingValue" :content="ratingValue" />
    <meta itemprop="bestRating" content="5" />
    <meta itemprop="ratingCount" :content="ratingCount" />
    {{ starRatingText }}
  </span>
</a>
